module.exports = __webpack_public_path__ + "static/pokoj-nr1-photo01-82e616aafb9889f9832816f1e81372c5.jpg";